import "./OurWorks.scss"
import OurVideo from "./OurVideo/OurVideo"
import OurClients from "./Clients/Clients";
import {useEffect, useState} from "react";
import OurGraphic from "./OurGraphic/OurGraphic";
import {Client, GalleryItem, WorkItem} from "../../types";



interface WorksProps {
    workClients: Client[];
    workItems: WorkItem[];
    workGraphic: GalleryItem[];
}

function Works({ workClients, workItems, workGraphic }: WorksProps) {

    console.log(workItems)

    return (
        <>
            <OurClients
                workClients={workClients}
                workItems={workItems}
                galleryData={workGraphic}
            />
            <OurVideo
                allWorkItems={workItems}
                title={true}
            />
            <div id="graphis"/>
                <OurGraphic
                    galleryData={workGraphic}
                />
        </>
    );
}

export default Works;

